import React, { createContext } from "react";
import { Link } from "react-router-dom";

import "./ContactsPage.css";

import Header from "../components/Header/Header";
import Cover from "../components/Cover/Cover";
import Address from "../components/Address/Address";
import Tetrad from "../components/Tetrad/Tetrad";
import Footer from "../components/Footer/Footer";

function ContactsPage() {
  return (
    <div className="equippage">
		<Header />
        <Cover covermode="none"/>
        <div className="body">
            <Tetrad />
        </div>
		<Address />
		<Footer />
    </div>
  );
}

export default ContactsPage;
